const hasWindow = (typeof window !== 'undefined');
export default hasWindow;
